<template>
  <v-checkbox
    :loading="loading"
    :label="required ? `${label}*`: label"
    :required="required"
    v-model="value"
    :error-messages="errorMessages"
    :hint="hintText"
    :readonly="readonly"
    @change="$emit('input', $event)"
    :name="name"
    :disabled="disabled"
  ></v-checkbox>
</template>

<script>
  import fieldMixin from "./mixins/fieldMixin";

  export default {
    name: "CheckboxField",
    mixins: [fieldMixin],
    data: () => ({
      loading: false,
      error: false,
    }),
    methods: {
    },
  }
</script>

<style scoped>

</style>
